import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "submitButton", "nameError", "dropdown"]

  connect() {
    this.debounceTimer = null
    this.debounceDelay = 300
    this.minSearchLength = 3
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  search() {
    const query = this.nameTarget.value.trim()

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    if (query.length < this.minSearchLength) {
      this.hideDropdown()
      return
    }

    this.debounceTimer = setTimeout(() => {
      this.performSearch(query)
    }, this.debounceDelay)
  }

  async performSearch(query) {
    const url = `https://en.wikipedia.org/w/api.php?action=opensearch&search=${encodeURIComponent(query)}&limit=5&format=json&origin=*`

    try {
      const response = await fetch(url)
      const data = await response.json()
      this.showResults(data)
    } catch (error) {
      this.hideDropdown()
    }
  }

  showResults(data) {
    const titles = data[1] || []

    if (titles.length === 0) {
      this.hideDropdown()
      return
    }

    this.dropdownTarget.innerHTML = titles
      .map(title => `<li class="wikipedia-dropdown-item" data-action="click->create-recommendation#selectResult">${title}</li>`)
      .join('')

    this.dropdownTarget.classList.remove('is-hidden')
  }

  selectResult(event) {
    this.nameTarget.value = event.target.textContent
    this.hideDropdown()
    this.hideNameError()
  }

  hideDropdown() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add('is-hidden')
      this.dropdownTarget.innerHTML = ''
    }
  }

  handleKeydown(event) {
    if (!this.hasDropdownTarget || this.dropdownTarget.classList.contains('is-hidden')) {
      return
    }

    const items = this.dropdownTarget.querySelectorAll('.wikipedia-dropdown-item')
    const currentIndex = Array.from(items).findIndex(item => item.classList.contains('is-highlighted'))

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        this.highlightItem(items, currentIndex + 1)
        break
      case 'ArrowUp':
        event.preventDefault()
        this.highlightItem(items, currentIndex - 1)
        break
      case 'Enter':
        if (currentIndex >= 0) {
          event.preventDefault()
          items[currentIndex].click()
        }
        break
      case 'Escape':
        this.hideDropdown()
        break
    }
  }

  highlightItem(items, index) {
    items.forEach(item => item.classList.remove('is-highlighted'))

    if (index < 0) index = items.length - 1
    if (index >= items.length) index = 0

    items[index].classList.add('is-highlighted')
  }

  handleBlur() {
    // Delay to allow click events on dropdown items to fire
    setTimeout(() => {
      this.hideDropdown()
    }, 200)
  }

  validateForm(event) {
    const hasName = this.nameTarget.value.trim().length > 0

    if (!hasName) {
      event.preventDefault()
      this.showNameError()
      return false
    }

    this.hideNameError()
    return true
  }

  showNameError() {
    this.nameErrorTarget.classList.remove("is-hidden")
  }

  hideNameError() {
    this.nameErrorTarget.classList.add("is-hidden")
  }
}
